import { useEffect, useRef, useState } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import QRCodeInputView from "./QRCodeInputView";
import QRCodeResultView from "./QRCodeResultView";
import QRCodeType from "./QRCodeType";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function QRCodeGeneratorMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "QR Code Generator & Barcode Generator Free",
  };

  //qrcode input value
  const [qrCodeInputValue, setQRCodeInputValue] = useState({
    value: "",
    type: QRCodeType.QR_CODE,
    popupShowing: false,
  });

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/qr_generator", title: "Generate QR Code For Free" },
    data2: { link: "/qr_generator", title: "Barcode Generator Free" },
    data3: { link: "/qr_generator", title: "Generate QR Codes For Business" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageContext.Provider value={{ qrCodeInputValue, setQRCodeInputValue }}>
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Generate QR codes online instantly. Create custom QR codes for URLs, text, and more with our fast, secure, and free QR code generator tool."
      ></meta>
      <meta
        name="keywords"
        content="qr code generator, generate qr code, create qr code online, qr code maker, qr generator online, custom qr code, free qr code generator, qr code creator, qr code tool, qr code generator free, online qr code maker, qr code generator for website, qr code generator for business, qr code generator tool, qr code generator online free"
      ></meta>

      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={false} />
        {/* QR Code input view */}
        <QRCodeInputView />
        {/* QR Code result view */}
        <QRCodeResultView />
        {/* Mid Section */}
        <MiscPageMidSection description="Our Barcode & QR Code Generator website provides a fast, secure, and reliable way to create barcodes and QR codes without requiring an internet connection. Built to work fully offline, this powerful tool allows users to generate codes directly on their device, ensuring complete privacy and data security. Whether you need to create codes for products, websites, payments, business cards, inventory, or marketing campaigns, this platform delivers accurate and high-quality results. Users can also choose online access when needed, making it flexible enough to function as a barcode generator online and QR code generator online while still offering offline processing. With customizable options such as size, color, format, and data type, users can easily create professional-looking codes for both personal and business use. Optimized for speed and usability, the generator supports multiple barcode standards and QR code formats, ensuring compatibility across devices and scanners. Ideal for businesses, retailers, educators, and marketers, this website simplifies code creation while maintaining reliability and performance. If you are searching for a secure barcode & QR code generator, a flexible barcode generator online, or a user-friendly QR code generator online with offline support, this platform delivers efficient solution designed for modern workflows." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Enter",
            step2: "Text",
            step3: "Generate",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="Barcode & QR Code Generator"
          why_use={[
            {
              title: "Quick and Easy Information Sharing",
              description:
                "Our Barcode & QR code generator makes it easy to share information like website links, product details, contact info, and payment links. Using a QR code generator online or offline allows instant access by scanning, saving time and effort.",
            },
            {
              title: "Improves Business Efficiency",
              description:
                "With a barcode generator online, businesses can manage inventory, billing, and product tracking efficiently. Barcodes help reduce manual errors and speed up daily operations across retail and logistics.",
            },
            {
              title: "Offline and Secure Code Generation",
              description:
                "Our offline Barcode & QR code generator ensures complete data privacy since files and data stay on your device. This is ideal for secure environments where online barcode generator access is limited.",
            },
            {
              title: "Boosts Marketing and Engagement",
              description:
                "This QR code generator online helps businesses connect customers to websites, social media, offers, and apps. QR codes improve user engagement and make digital marketing campaigns more effective.",
            },
            {
              title: "Cost-Effective and Free to Use",
              description:
                "Using a free Barcode generator or QR code generator free eliminates the need for expensive software or hardware. It is a budget-friendly solution for startups, small businesses, and individuals.",
            },
            {
              title: "Useful Across Multiple Industries",
              description:
                "Our Barcode & QR code generator is widely used in retail, healthcare, education, logistics, and events. From inventory management to student IDs, barcode generator online tools simplify workflows.",
            },
            {
              title: "Enhances Customer Experience",
              description:
                "QR codes created using a QR code generator online allow customers to quickly access menus, invoices, manuals, and support pages, improving convenience and customer satisfaction.",
            },
            {
              title: "Supports Multiple Barcode Formats",
              description:
                "Modern barcode generators online support QR codes, Code 128, EAN, UPC, and other formats, ensuring compatibility with scanners, mobile devices, and POS systems.",
            },
            {
              title: "Eco-Friendly and Paperless Solution",
              description:
                "Our QR code generator reduces the need for printed materials by enabling digital access to information, supporting paperless and environmentally friendly operations.",
            },
          ]}
        />
        {/* FAQ */}
        <MiscFAQ
          faq_list={[
            {
              title: "What is a QR code generator?",
              description:
                "A QR code generator is a tool that creates a scannable code containing information such as a website URL, text, contact details, or other supported data. People can scan the code using a smartphone camera or QR code reader to access the encoded information.",
            },
            {
              title: "How do I create a QR code online for free?",
              description:
                "Open the QR Code Generator on ShivaPDF.com, enter the information you want to encode, and generate the QR code. If download options are available, save the generated image and test it with a QR code scanner before sharing or printing it.",
            },
            {
              title: "Can I generate a QR code for free?",
              description:
                "A free QR code generator lets you create scannable codes without purchasing dedicated software. Check ShivaPDF's current tool page for available QR code types, download formats, and any usage restrictions.",
            },
            {
              title: "Can I create a QR code offline?",
              description:
                "Offline QR code generation is possible when the generator and its required resources are available locally on your device. If ShivaPDF's QR code generator supports local browser processing, you may be able to create codes without an active internet connection after the page has loaded.",
            },
            {
              title: "Does ShivaPDF generate QR codes locally?",
              description:
                "Local processing depends on how the tool is implemented. If the QR code is generated entirely in your browser, the information you enter can be processed on your device rather than sent to a remote generation server. Check the tool's privacy information to confirm its behavior.",
            },
            {
              title: "Is it safe to use an online QR code generator?",
              description:
                "Safety depends on how the generator handles the information you enter and the destination encoded in the QR code. Avoid including sensitive information in publicly accessible codes, review the website's privacy policy, and test QR codes before sharing them.",
            },
            {
              title: "Can I create a QR code for a website URL?",
              description:
                "Yes, a URL QR code stores a website address that people can open by scanning the code. Enter the complete URL, generate the QR code, and test it to confirm that it opens the intended website.",
            },
            {
              title: "Can I create a QR code for text?",
              description:
                "Yes, a text QR code can encode a short message, instructions, or other plain text. The amount of text that fits depends on the QR code's capacity and the encoding settings supported by the generator.",
            },
            {
              title: "Can I generate a QR code for Wi-Fi?",
              description:
                "A Wi-Fi QR code can store network details so compatible phones can connect more easily. This feature requires a generator that supports Wi-Fi QR codes. Avoid sharing network QR codes publicly if you want to keep your Wi-Fi credentials private.",
            },
            {
              title: "Can I create a QR code for contact details?",
              description:
                "Some QR code generators support contact information, allowing people to scan a code to access details such as a name, phone number, email address, or business information. Available contact formats depend on the tool.",
            },
            {
              title: "Can I create a QR code for an email address?",
              description:
                "A QR code can encode an email address or a mailto link when the generator supports the required format. Scanning it may open the device's default email application, depending on the phone and its settings.",
            },
            {
              title: "Can I generate a QR code for a phone number?",
              description:
                "You can encode a phone number in a QR code using a suitable text or telephone-link format. On supported devices, scanning the code may make it easier to open the phone dialer with the number entered.",
            },
            {
              title: "Can I download a QR code as an image?",
              description:
                "A QR code generator may provide image download options such as PNG or SVG. Check ShivaPDF's available formats and choose one suitable for your intended use, including websites, documents, labels, or print materials.",
            },
            {
              title: "Can I print a QR code?",
              description:
                "Yes, a downloaded QR code can be added to flyers, posters, business cards, product packaging, and other printed materials. Use a clear, high-resolution version, maintain sufficient contrast, and test a printed sample before producing large quantities.",
            },
            {
              title: "Can I customize the color of a QR code?",
              description:
                "Some QR code generators allow you to change foreground and background colors. Keep strong contrast between the code and its background, avoid obscuring important code patterns, and test the finished QR code with different devices.",
            },
            {
              title: "Can I add a logo to a QR code?",
              description:
                "Some generators support adding a logo or image to a QR code. A logo can cover important code elements if it is too large, so use a generator with appropriate error-correction support and test the result before sharing it.",
            },
            {
              title: "Do QR codes expire?",
              description:
                "A static QR code does not normally expire by itself because its information is encoded directly in the pattern. However, a URL may stop working if the destination page is removed, and dynamic QR codes may depend on an external service or subscription.",
            },
            {
              title: "What is the difference between static and dynamic QR codes?",
              description:
                "A static QR code stores its information directly in the code and usually cannot be changed after creation. A dynamic QR code typically points to a managed URL that can redirect to different destinations, often through an external service.",
            },
            {
              title: "Can I create a QR code without signing up?",
              description:
                "Some QR code generators allow users to create codes without registering for an account. Check ShivaPDF's QR Code Generator page to confirm whether account creation is required.",
            },
            {
              title: "Can I use a QR code generator on Windows and Mac?",
              description:
                "A browser-based QR code generator can work on Windows and macOS through a supported web browser. You generally do not need to install separate desktop software if the tool supports your browser.",
            },
            {
              title: "Can I create QR codes on an iPhone or Android phone?",
              description:
                "You may be able to generate QR codes through a mobile browser. The experience depends on the website's mobile layout, browser compatibility, and the QR code options available in the tool.",
            },
            {
              title: "Why is my generated QR code not scanning?",
              description:
                "A QR code may fail to scan if it is blurry, too small, low in contrast, cropped, or partially covered. Generate a clear image, maintain a quiet margin around the code, and test it with multiple QR code readers.",
            },
            {
              title: "Are QR codes generated by ShivaPDF static or dynamic?",
              description:
                "Whether a QR code is static or dynamic depends on the generator's implementation. A static code stores its data directly, while a dynamic code typically uses a managed destination. Check ShivaPDF's tool details to confirm which type it creates.",
            },
            {
              title: "Why should I use ShivaPDF's QR code generator?",
              description:
                "A browser-based QR code generator provides a convenient way to create scannable codes for links and other supported information. Visit ShivaPDF's tool page to check its available QR code types, customization options, download formats, and privacy details.",
            },
          ]} />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Recommended Tools */}
        <MiscRecommendedPages />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default QRCodeGeneratorMain;
